export default __webpack_public_path__ + "static/media/abaut.dc654821.webp";